import { DatasourceBuilderActionTypes } from './constants';
import { renameDuplicate, renameFieldDuplicate } from '../../utils/renameDuplicate';
import { FindFormIndex } from '../../utils/FindFormIndex';
import { updateFieldById } from '../../utils/updateFieldById';

interface State {
    currentDatasourceId: any,
    DatasourceList: any,
    DatasourceId: any | "",
    config?: any | {};
    fieldList: any[],
    boadList: any[],
    panelItems: any[],
    expandedKeys: any[]
}

const INIT_STATE = {
    currentDatasourceId: "",
    DatasourceList: [],
    DatasourceId: "",
    fieldList: [],
    boadList: [],
    panelItems: [],
    subDatasources: [],
    expandedKeys: [],

    config: {
        publicSettings: {
            tableName: '',
            isShowRownumber: true,
            orderDataType: 'DESC',
            style: {
                width: 600,
                height: 500,
            }
        }
    },
};

const DatasourceBuilder = (state: State = INIT_STATE, action: any): any => {
    // تابع بازگشتی برای برگرداندن index و خود نود

    switch (action.type) {

        case DatasourceBuilderActionTypes.CHANGE_EXPANDKEY:

            return {
                ...state,
                expandedKeys: action.payload,
            };

        case DatasourceBuilderActionTypes.CHANGE_CURRENTDatasource:

            const found = FindFormIndex(state.DatasourceList, action.payload);

            let s_boadList1 = state.boadList;
            let s_config1 = state.config;
            if (found) {
                s_boadList1 = found.node.boadList || [];
                s_config1 = found.node.config;
            }

            return {
                ...state,
                currentDatasourceId: action.payload,
                boadList: s_boadList1,
                config: s_config1
            };

        case DatasourceBuilderActionTypes.CHANGE_DatasourceLIST:
            var s_CurrentDatasourceId = state.currentDatasourceId;
            var s_DatasourceList: any = [];
            if (s_CurrentDatasourceId === "")
                s_DatasourceList = action.payload
            else {
                const DatasourceIndex = state.DatasourceList.findIndex((object: any) => { return object.id === state.currentDatasourceId })
                var s_DatasourceList = state.DatasourceList;

                if (DatasourceIndex !== -1) {
                    s_DatasourceList[DatasourceIndex].children = action.payload
                }
            }
            return {
                ...state,
                DatasourceList: s_DatasourceList,
            };

        case DatasourceBuilderActionTypes.CHANGE_ADDDatasourceLIST:

            return {
                ...state,
                DatasourceList: action.payload,
                boadList: [],
                config: {
                    publicSettings: {
                        tableName: '',
                        isShowRownumber: true,
                        orderDataType: 'DESC',
                        style: {
                            width: 400,
                            height: 360,
                        }
                    }
                }

            };

        case DatasourceBuilderActionTypes.CHANGE_RESET_INITIAL_STATE:
            return {
                ...INIT_STATE,
            };

        case DatasourceBuilderActionTypes.CHANGE_Datasource_PUBLICSETTING:

            let s_activeKeyRownumber = state.config.publicSettings.activeKey
            if (action.payload.activeKey !== undefined) {
                s_activeKeyRownumber = action.payload.activeKey
            }

            let s_isShowRownumber = state.config.publicSettings.isShowRownumber
            if (action.payload.isShowRownumber !== undefined) {
                s_isShowRownumber = action.payload.isShowRownumber
            }

            let s_tableName = state.config.publicSettings.tableName
            if (action.payload.tableName !== undefined) {
                s_tableName = action.payload.tableName
            }


            let s_orderDataType = state.config.publicSettings.orderDataType
            if (action.payload.orderDataType !== undefined) {
                s_orderDataType = action.payload.orderDataType
            }

            let s_styleWidth = state?.config?.publicSettings.style?.width
            if (action?.payload?.style?.width !== undefined) {
                s_styleWidth = action?.payload?.style?.width
            }

                 let s_styleHight = state?.config?.publicSettings?.style?.height
            if (action?.payload?.style?.height !== undefined) {
                s_styleHight = action?.payload?.style?.height
            }

            let s_filePath = state.config.publicSettings.filePath
            if (action.payload.filePath !== undefined) {
                s_filePath = action.payload.filePath
            }

            const s_Config = {
                ...state.config,
                publicSettings: { ...state.config.publicSettings, activeKey: s_activeKeyRownumber, tableName: s_tableName, isShowRownumber: s_isShowRownumber, orderDataType: s_orderDataType,filePath:s_filePath,style: {width: s_styleWidth,height:s_styleHight } }
            }
            const s_DatasourceListC = [...state.DatasourceList]; // shallow copy سطح اول

            const foundC = FindFormIndex(s_DatasourceListC, state.currentDatasourceId);

            if (foundC) {
                foundC.node.config = s_Config;  // تغییر مستقیم روی نود پیدا شده
            }

            return {
                ...state,
                config: s_Config,
            };

        case DatasourceBuilderActionTypes.CHANGE_Datasource_TABLENAME:
            return {
                ...state,
                config: { ...state.config, tableName: action.payload?.tableName },
            };

        case DatasourceBuilderActionTypes.CHANGE_DatasourceID:
            return {
                ...state,
                DatasourceId: action.payload,
            };

        case DatasourceBuilderActionTypes.CHANGE_FIELD:
            return {
                ...state,
                fieldList: action.payload,
            };

        // case DatasourceBuilderActionTypes.CHANGE_BOAD:
        //     var t1 = renameFieldDuplicate(action.payload);
        //     return {
        //         ...state,
        //         boadList: t1,
        //     };

        case DatasourceBuilderActionTypes.CHANGE_BOAD: {
            const s_DatasourceList = [...state.DatasourceList]; // shallow copy سطح اول
            const t1 = renameFieldDuplicate(action.payload);

            const found = FindFormIndex(s_DatasourceList, state.currentDatasourceId);

            if (found) {
                found.node.boadList = t1;  // تغییر مستقیم روی نود پیدا شده
            }

            return {
                ...state,
                DatasourceList: s_DatasourceList,
                boadList: t1,
            };
        }

        case DatasourceBuilderActionTypes.CHANGE_Datasource_SUBDatasource:
            return {
                ...state,
                subDatasources: action.payload,
            };

        // case DatasourceBuilderActionTypes.CHANGE_BOAD_SETTING:
        //     const boadIndex = state.boadList.findIndex(object => { return object.id === action.payload.id })
        //     const s_boadList = state.boadList;
        //     const ddd = s_boadList

        //     if (boadIndex !== -1) {
        //         s_boadList[boadIndex] = { ...s_boadList[boadIndex], ...action.payload }
        //     }

        //     return {
        //         ...state,
        //         boadList: s_boadList,
        //     };

        // case DatasourceBuilderActionTypes.CHANGE_BOAD_SETTING: {
        //     let foundBoadIndex = -1;
        //     let foundFieldIndex = -1;

        //     state.boadList.forEach((item, boardIndex) => {
        //         const fieldIndex = item.fields.findIndex((object: any) => { return object.id === action.payload.id })

        //         //   item.fields.findIndex(
        //         //     (f: any) => f.id === action.payload.id
        //         //   );
        //         if (fieldIndex !== -1) {
        //             foundBoadIndex = boardIndex;
        //             foundFieldIndex = fieldIndex;
        //         }
        //     });


        //     if (foundBoadIndex === -1 || foundFieldIndex === -1) return state;


        //     const newBoadList = state.boadList.map((boad, i) => {
        //         if (i === foundBoadIndex) {
        //             const newFields = boad.fields.map((field: any, j: any) => {
        //                 if (j === foundFieldIndex) {
        //                     return { ...field, ...action.payload };
        //                 }
        //                 return field;
        //             });
        //             return { ...boad, fields: newFields };
        //         }
        //         return boad;
        //     });
        //     return {
        //         ...state,
        //         boadList: newBoadList,
        //     };
        // }

        case DatasourceBuilderActionTypes.CHANGE_BOAD_SETTING: {
            const { id, ...updates } = action.payload;
            const d=updateFieldById(state.boadList, id, updates)

            const s_DatasourceList = [...state.DatasourceList]; // shallow copy سطح اول

            const found = FindFormIndex(s_DatasourceList, state.currentDatasourceId);

            if (found) {
                found.node.boadList = d;  // تغییر مستقیم روی نود پیدا شده
            }

            return {
              ...state,
              DatasourceList:s_DatasourceList,
              boadList: d,
            };
          }

        default:
            return state;
    }
};

export default DatasourceBuilder;
